const dateRangePickerStyles = {
  chip: {
    fontSize: '0.875rem',
    height: 32,
  },

  activeChip: {
    fontSize: '0.875rem',
    height: 32,
    backgroundColor: '#e0d8f6',
    color: '#5236AB',
  },

  popoverContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    padding: 2,
    width: 280,
  },

  dateApplyContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 1,
  },

  dateApplyButton: {
    backgroundColor: '#5236AB',
    color: '#fff',
    fontSize: '0.75rem',
    padding: '6px 12px',
    textTransform: 'none',
    borderRadius: 4,
    minWidth: 64,
    '&:hover': {
      backgroundColor: '#3f2891',
    },
  },

  clearButton: {
    backgroundColor: '#e0d8f6',
    color: '#5236AB',
    fontSize: '0.75rem',
    padding: '6px 12px',
    textTransform: 'none',
    borderRadius: 4,
    minWidth: 64,
    '&:hover': {
      backgroundColor: '#d3c7f0',
    },
  },
};

export default dateRangePickerStyles;
